import { createSelector } from 'reselect';

const adminSelector = state => state.admin;

export const templates = createSelector(adminSelector, state => state.emailTemplates);
export const current = createSelector(adminSelector, state => state.currentEmailTemplate);

export function find(state) {
  return function (siteId, templateName) {
    return createSelector(adminSelector, state =>
      state.emailTemplates.find(t => t.site.id === siteId && t.description === templateName)
    )(state);
  };
}
